module.exports = __webpack_public_path__ + "static/media/creditMemoExample.b3a21a57.png";